import React, { useState } from "react";
import {Close as CloseIcon} from "@mui/icons-material";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import { ShepTab, ShepTabs } from "@/components/GenericComponents/ShepTab";
import MessageContent from "./MessageContent";

const MessagePopup = (props) => {
  const [tabValue, setTabValue] = useState(0);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);

    // heap.io
    switch (newValue) {
        case 0:
            window.heap.track("Messages - Select Inbox Tab");
            break;
        case 1:
            window.heap.track("Messages - Select Archive Tab");
            break;
    }
  };

  return (
    <Dialog
      className="workflow-settings-container"
      open={props.open}
      onClose={props.onClose}
      maxWidth="xl"
      PaperProps={{
        style: {
          backgroundColor: "transparent",
          boxShadow: "none",
          width: "2000px",
          height: "1600px",
        },
      }}
      sx={{ zIndex: "1500" }}
    >
      <DialogTitle
        className="workflow-settings-heading"
        style={{
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "var(--primary-main)",
          color: "var(--default-light)",
          fontSize: "24px",
          borderRadius: "15px 15px 0 0",
        }}
      >
        <div style={{ display: "flex" }}>
          <div style={{ fontWeight: "var(--font-semi-bold)" }}>Messages</div>
          <div></div>
        </div>
        <IconButton
          className="closeIconButton"
          style={{ color: "var(--default-light)" }}
          onClick={props.onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className="dialogContent">
        <Box
          sx={{
            flex: "auto",
            marginLeft: "5px",
            width: "99%",
            backgroundColor: "var(--disabled)",
          }}
        >
          <ShepTabs
            sx={{
              margin: "40px 30px 30px 0",
              borderBottom: "1px solid var(--primary-main)",
            }}
            variant="primary"
            value={tabValue}
            onChange={handleTabChange}
            aria-label="workflow tabs"
          >
            <ShepTab
              variant="primary"
              key="1"
              label={"Inbox"}
              iconPosition="start"
            />
            <ShepTab
              variant="primary"
              key="2"
              label={"Archive"}
              iconPosition="start"
            />
          </ShepTabs>
          <Box>
            {tabValue === 0 && <MessageContent isArchive={false} />}
            {tabValue === 1 && <MessageContent isArchive={true} />}
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default MessagePopup;
